import React, { useContext, useEffect, useState } from "react";
import { ProductsContext } from "../../../../utils/stateHandlers/contexts";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export default function Dimension(props) {
  const { productState, productDispatch } = useContext(ProductsContext);
  const { clear, validationErrors, style, productInfo, sizeType, priceLoaded } =
    productState;
  const [localDimension, setLocalDimension] = useState(null);
  const field = props.field;
  const standard = _.filter(field.values, function (option) {
    return option.ga !== "";
  });
  const standardOptions = sizeOptionsFormatting(standard);
  const mto = _.filter(field.values, function (option) {
    return option.ga === "";
  });
  const mtoOptions = sizeOptionsFormatting(mto);

  function sizeOptionsFormatting(options) {
    const sizeOptions = [];
    const sortedOptions = _.orderBy(options, "in", "desc");
    _.map(sortedOptions, function (option) {
      const newLabel = `${option.in}in / ${`${option.ga}ga`} / ${option.mm}mm`;
      const mtoNewLabel = `${option.in}in / ${option.mm}mm`;
      sizeOptions.push({
        label: sizeType === "standard" ? newLabel : mtoNewLabel,
        value: option.value,
      });
    });
    return sizeOptions;
  }

  function selectDimension(dimension) {
    if (dimension === "None") {
      productDispatch({
        type: "setValidationErrors",
        payload: [...validationErrors, "dimension"],
      });
    } else {
      const remove = _.remove(validationErrors, "dimension");
      productDispatch({ type: "setValidationErrors", payload: remove });
    }
    productDispatch({ type: "setClear", payload: false });
    setLocalDimension(dimension);
    if (style === "CHM" && field.name === "dimension") {
      productDispatch({
        type: "setCharmDimension",
        payload: dimension,
      });
    } else if (style === "CIR" && field.name === "dimension") {
      productDispatch({
        type: "setCircleDimension",
        payload: dimension,
      });
    }
    productDispatch({
      type: "updateFields",
      field: "dimension",
      payload: dimension,
    });
  }

  useEffect(() => {
    if (clear && field.template === "dropdown") {
      productDispatch({ type: "setClear", payload: false });
      if (!field.default || props.isMill) {
        productDispatch({
          type: "setValidationErrors",
          payload: [...validationErrors, "dimension"],
        });
        setLocalDimension("None");
      } else {
        setLocalDimension(field.default ? field.default : "None");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clear]);

  return (
    <>
      {field.template === "dropdown" ? (
        <Stack>
          <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
            {field.label}
          </Typography>
          {style === "RW" ? (
            <>
              <FormControl>
                <RadioGroup
                  row
                  value={sizeType}
                  disabled={!priceLoaded}
                  onChange={(e) => {
                    setLocalDimension("None");
                    productDispatch({
                      type: "updateFields",
                      field: "dimension",
                      payload: "None",
                    });
                    productDispatch({
                      type: "setValidationErrors",
                      payload: [...validationErrors, "dimension"],
                    });
                    productDispatch({
                      type: "setSizeType",
                      payload: e.target.value,
                    });
                  }}
                >
                  <FormControlLabel
                    value="standard"
                    control={<Radio />}
                    label={<Typography>Standard</Typography>}
                  />
                  <FormControlLabel
                    value="mto"
                    control={<Radio />}
                    label={<Typography>Made To Order (MTO)</Typography>}
                  />
                </RadioGroup>
              </FormControl>
              <FormControl error={localDimension === "None" ? true : false}>
                <Select
                  value={localDimension === null ? ".032IN" : localDimension}
                  disabled={!priceLoaded}
                  size="small"
                  sx={{ width: "100%" }}
                  onChange={(e) => {
                    selectDimension(e.target.value);
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        border: "1px solid #939598",
                        borderRadius: "0",
                        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                      },
                    },
                  }}
                >
                  <MenuItem value="None">
                    <em>Select...</em>
                  </MenuItem>
                  {sizeType === "standard"
                    ? standardOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))
                    : mtoOptions.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                </Select>
                <FormHelperText>
                  {localDimension === "None" ? "Please Make A Selection" : ""}
                </FormHelperText>
              </FormControl>
            </>
          ) : (
            <FormControl error={localDimension === "None" ? true : false}>
              <Select
                value={localDimension === null ? field.default : localDimension}
                size="small"
                sx={{ width: "100%" }}
                disabled={!priceLoaded}
                onChange={(e) => {
                  selectDimension(e.target.value);
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      border: "1px solid #939598",
                      borderRadius: "0",
                      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    },
                  },
                }}
              >
                <MenuItem value="None">
                  <em>Select...</em>
                </MenuItem>
                {field.values &&
                  field.values.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
              </Select>
              <FormHelperText>
                {localDimension === "None" ? "Please Make A Selection" : ""}
              </FormHelperText>
            </FormControl>
          )}
        </Stack>
      ) : (
        <Grid container key={field.name}>
          <Grid item xs={8}>
            <Stack>
              <Typography
                sx={{
                  fontWeight: "700",
                  paddingBottom: ".3rem",
                }}
              >
                Width
              </Typography>
              <TextField
                color="primary"
                disabled={!priceLoaded}
                onChange={(e) => {
                  productDispatch({
                    type: "updateFields",
                    field: "dimension",
                    payload: e.target.value,
                  });
                }}
                type="number"
                size="small"
                sx={{
                  width: "100%",
                  margin: "unset",
                }}
                defaultValue={field.default}
              />
            </Stack>
          </Grid>
          <Grid item xs={1} />
          <Grid item xs={3}>
            <Stack>
              <Typography
                sx={{
                  fontWeight: "700",
                  paddingBottom: ".3rem",
                }}
              >
                Units
              </Typography>
              <Select
                defaultValue={field.default_unit ? field.default_unit : "None"}
                renderValue={_.find(productInfo, function (productInfo) {
                  return productInfo === "dimension_unit";
                })}
                sx={{ width: "100%" }}
                disabled={!priceLoaded}
                size="small"
                onChange={(e) => {
                  productDispatch({
                    type: "updateFields",
                    field: "dimension_unit",
                    payload: e.target.value,
                  });
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      border: "1px solid #939598",
                      borderRadius: "0",
                      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                    },
                  },
                }}
              >
                <MenuItem value="None">
                  <em>Select...</em>
                </MenuItem>
                {field.units &&
                  field.units.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
              </Select>
            </Stack>
          </Grid>
        </Grid>
      )}
    </>
  );
}
